module.exports = __webpack_public_path__ + "static/media/javascript.a375948a.png";